<template>
    <v-page-data-table
            title="我的待办"
            key-name="taskId"
            :fields="fields"
            ref="doc"
            @create="onDetail"
            @meeting="onStartProcess('meeting','会议纪要流程')"
            @receive="onStartProcess('receive','收文流程')"
            @send="onStartProcess('send','发文流程')"
            @orgSend="onStartProcess('orgSend','院党委发文流程')"
            @deptSend="onStartProcess('deptSend','所党委流程')"
            @request="onStartProcess('request','请示件流程')"
            @review="onStartProcess('review','呈阅件流程')"
            :show-edit="false"
            :show-delete="false"
            :row-actions="rowActions"
            delete-api="DOC_DELETE"
            query-api="BPM_TODO_QUERY">

        <template v-slot:title="{item}">
            <v-link-text :text="item.title" @click="onDetail(item)"></v-link-text>
        </template>
    </v-page-data-table>
</template>

<script>
    import TodoQueryFields from "./fields/TodoQueryFields";

    export default {
        name: "DocQuery",
        data() {
            return {
                fields: TodoQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '发起流程',
                        color: 'primary',
                        icon: "mdi-plus-circle",
                        action: 'create',
                        children: [
                            {
                                text: '会议纪要流程',
                                action: 'meeting',
                                display: 'text',
                                icon: 'mdi-calendar-month'
                            },
                            {
                                text: '收文流程',
                                action: 'receive',
                                display: 'text',
                                icon: 'mdi-briefcase-download-outline'
                            },
                            {
                                text: '发文流程',
                                display: 'text',
                                action: 'send',
                                icon: 'mdi-briefcase-upload-outline'
                            },
                            {
                                text: '请示件流程',
                                display: 'text',
                                action: 'request',
                                icon: 'mdi-account-check'
                            },
                            {
                                text: '呈阅件流程',
                                display: 'text',
                                action: 'review',
                                icon: 'mdi-account-check-outline'
                            }
                        ]
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.docId : undefined;
                let taskId = item ? item.taskId : undefined;
                let instanceId = item ? item.instanceId : undefined;
                this.$router.apmRoute("docDetail", {id: id, taskId: taskId, instanceId: instanceId,source:'todo'});
            },
            viewImage(url) {
                window.open(url, '_blank');
            },
            onStartProcess(processType, processTypeName) {
                this.$router.apmRoute("docDetail", {type: processTypeName,source:'todo'});
            }
        }
    }
</script>
